import React, { useLayoutEffect, useState } from 'react';

import { textUtils } from '@instinet-analytics/core-lib';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import {
    RowFilterSign,
    RowFilterState,
} from 'widgets/store/grid/filters/FilterState';

interface SelectedRowsEditorProps {
    selectedRows: number[];
    onAddRowFilter: (filter: RowFilterState) => void;
}

const { pluralise } = textUtils;

export default function SelectedRowsEditor(props: SelectedRowsEditorProps) {
    const { selectedRows, onAddRowFilter } = props;

    const [showIncludeRowsMessage, setShowIncludeRowsMessage] = useState(
        !!selectedRows.length
    );
    useLayoutEffect(() => {
        setShowIncludeRowsMessage(!!selectedRows.length);
    }, [selectedRows, setShowIncludeRowsMessage]);

    const onFilterSelectedRows = (sign: RowFilterSign) => () => {
        onAddRowFilter({
            rowIds: selectedRows,
            sign,
        });
        setShowIncludeRowsMessage(false);
    };

    if (!showIncludeRowsMessage) {
        return <></>;
    }

    const rowCount = selectedRows.length;

    return (
        <div className="SelectedRowsMessage">
            <p>
                There {rowCount > 1 ? 'are' : 'is'} <strong>{rowCount}</strong>{' '}
                {pluralise(rowCount, 'order')} selected
            </p>
            <button
                className="ui button text-link Button"
                onClick={onFilterSelectedRows('INCLUDE')}
            >
                Include
            </button>
            <span className="divider" />
            <button
                className="ui button text-link Button"
                onClick={onFilterSelectedRows('EXCLUDE')}
            >
                Exclude
            </button>
            <Icon
                className="action"
                name="close"
                onClick={() => setShowIncludeRowsMessage(false)}
            />
        </div>
    );
}
